import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions from '~/Actions';
import permission from '~/skills/permission';
import {
  Select,
  MenuItem,
  TableRow,
  TableCell,
  TableHead,
  TableContainer,
  TableBody,
  Table,
} from '@material-ui/core';
import { ArrowBackIos, ArrowForwardIos, FirstPage, LastPage } from '@mui/icons-material';

import { S_Input, S_Btn_Search, S_Btn_Add, S_Select, S_Title } from '~/components/SearchItem';
import { T_TitleCell, T_Btn_Function, T_TableRow } from '~/components/TableItem';
import T_common from '~/components/TableItem/common';
import CheckDelete from '~/components/Dialog/CheckDelete';
import PageTitle from '~/components/PageTitle';
import AddAndEdit from './AddAndEdit';

class App extends Component {
  state={
    status: '',
    keyword: '',
    org_id: '',
    per_page: 10,
    page: 1,
    sort: true,
    sort_field: 'user_upd_time',
    view_checkDelete: false,
    view_addAndEdit: false,
    mode_addAndEdit: '',
    currentId: '',
    currentAct: '',
  }

  componentDidMount () {
    const { status, keyword, org_id } = this.state;
    this.data = { status, keyword, org_id };
    this.refresh();
    this.props.getOrgList();
  }

  refresh=() => {
    const { page, per_page, sort, sort_field } = this.state;
    const { status, keyword, org_id } = this.data;
    this.props.getUserList({
      page,
      per_page,
      body: {
        keyword,
        org_id,
        sort: sort ? 'desc' : 'asc',
        sort_field,
        status,
      },
    });
  }

  search=() => this.setState({ page: 1 }, () => this.refresh());

  _click_search=() => {
    const { status, keyword, org_id } = this.state;
    this.data = { status, keyword, org_id };
    this.search();
  }

  _delete=(id, act) => this.setState({ currentId: id, currentAct: act, view_checkDelete: true })
  _close_view_checkDelete=() => {
    // this.refresh();
    this.setState({ currentId: '', currentAct: '', view_checkDelete: false });
  }

  _add=() => this.setState({ view_addAndEdit: true, mode_addAndEdit: 'add' })
  _view=id => this.setState({ currentId: id, view_addAndEdit: true, mode_addAndEdit: 'view' })
  _edit=id => this.setState({ currentId: id, view_addAndEdit: true, mode_addAndEdit: 'edit' })
  _close_view_addAndEdit=() => {
    this.refresh();
    this.setState({ currentId: '', view_addAndEdit: false, mode_addAndEdit: '' });
  }

  toolBar=() => {
    const { orgList = [] } = this.props;
    const { status, keyword, org_id } = this.state;
    return (
      <div style={{ marginTop: 24, display: 'flex' }}>
        <div>
          <S_Title text='單位名稱' />
          <S_Select value={org_id} list={orgList} onChange={t => this.setState({ org_id: t })} />
        </div>
        <div style={{ marginLeft: 16 }}>
          <S_Title text='狀態' />
          <S_Select value={status} list={[{ value: '0', name: '未啟用' }, { value: '1', name: '啟用' }, { value: '2', name: '停用' }]} onChange={t => this.setState({ status: t })} />
        </div>
        <div style={{ marginLeft: 16 }}>
          <S_Title text='關鍵字' />
          <S_Input value={keyword} onChange={t => this.setState({ keyword: t })} onEnterKey={this._click_search} />
        </div>
        <div style={{ marginLeft: 16, display: 'flex', flexDirection: 'column-reverse' }}>
          <S_Btn_Search onClick={this._click_search} />
        </div>
      </div>
    );
  }

  toolBar2=() => (
    <div style={{ marginTop: 24, display: 'flex', alignItems: 'center' }}>
      <div style={{ color: '#064B6F', fontSize: 20, lineHeight: '24px', letterSpacing: '0.25%' }}>帳號清單</div>
      <S_Btn_Add onClick={this._add} style={{ marginLeft: 24 }} disabled={!this.props.canAdd} />
    </div>
  )

  renderTableTitle=() => {
    const { sort, sort_field } = this.state;
    const onChangeSort = t => {
      this.setState({ sort_field: t, sort: sort_field === t ? !sort : false }, () => this.search());
    };
    const ary = [
      { name: '序號' },
      { name: '使用者帳號', id: 'user_account' },
      { name: '姓名', id: 'user_user_name' },
      { name: '組織名稱', id: 'organization_organization_name' },
      { name: '電子信箱', id: 'user_email' },
      { name: '聯絡電話', id: 'user_tel_number' },
      { name: '上次更新時間', id: 'user_upd_time' },
      { name: '狀態', id: 'user_status' },
      { name: '權限名稱', id: 'group_name' },
      { name: '功能' },
    ];
    return (
      <TableHead>
        <TableRow style={{ height: 48 }}>
          {ary.map((o, i) => (
            <T_TitleCell
              key={i}
              text={o.name}
              arrow={!!o.id}
              bol={sort_field === o.id ? sort : true}
              onClick={() => onChangeSort(o.id)}
            />
          ))}
        </TableRow>
      </TableHead>
    );
  }

  renderTableBody=() => {
    const { userListInfo = {}, canEdit, canDel } = this.props;
    const { user_list = [], page = 0, total = 0 } = userListInfo;
    const { per_page } = this.state;
    const statusInfo = { 0: { text: '未啟用', color: 'rgba(0, 0, 0, 0.54)' }, 1: { text: '啟用', color: '#6D3A89' }, 2: { text: '停用', color: '#B00020' } };
    const cellStyle = { fontSize: 14 };
    let start = 0;
    if (page > 0) {
      start = (page - 1) * per_page + 1;
      if (start > total)start = 0;
    }
    return (
      <TableBody>
        {user_list.map((o, i) => (
          <T_TableRow key={i} backgroundColor= {i % 2 === 0 ? '#E0FDFF' : 'white'}>
            <TableCell align='center' style={cellStyle}>{i + start}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.account}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.user_name}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.org_name}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.email}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.tel_number}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.upd_time}</TableCell>
            <TableCell align='center' style={{ ...cellStyle, color: statusInfo[o.status].color }}>{statusInfo[o.status].text}</TableCell>
            <TableCell align='center' style={cellStyle}>{o?.group_name || '-'}</TableCell>
            <TableCell style={{ width: 214 }}>
              <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                <T_Btn_Function text='檢視' backgroundColor={T_common.type1} onClick={() => this._view(o.id)} />
                <T_Btn_Function text='編輯' backgroundColor={T_common.type2} onClick={() => this._edit(o.id)} style={{ marginLeft: 8, marginRight: 8 }} disabled={!canEdit} />
                <T_Btn_Function text='刪除' backgroundColor={T_common.type3} onClick={() => this._delete(o.id, o.account)} disabled={!canDel} />
              </div>
            </TableCell>
          </T_TableRow>
        ))}
      </TableBody>
    );
  }

  renderTableBar=() => {
    const { userListInfo = {} } = this.props;
    const { has_next = false, has_prev = false, page = 0, pages = 0, total = 0 } = userListInfo;
    const { per_page, page: statePage } = this.state;
    const returnPages = () => {
      const array = [];
      for (let i = 1; i <= pages; i++) {
        array.push(i);
      }
      return array;
    };
    const returnPers = () => [10, 20, 30, 40];
    const canFirst = page > 1;
    const canLast = page < pages;
    return (
      <div style={{ height: 48, display: 'flex', alignItems: 'center', width: '98%', backgroundColor: 'white', borderBottomRightRadius: 8, borderBottomLeftRadius: 8, paddingTop: 6, paddingBottom: 6 }}>
        <div style={{ flex: 1 }} />
        <FirstPage style={{ height: 24, width: 24, color: canFirst ? 'black' : 'gray', cursor: canFirst ? 'pointer' : 'default' }} onClick={() => { if (canFirst) this.setState({ page: 1 }, () => this.refresh()); }} />
        <ArrowBackIos style={{ marginLeft: 3, marginRight: 5, height: 16, width: 16, color: has_prev ? 'black' : 'gray', cursor: has_prev ? 'pointer' : 'default' }} onClick={() => { if (has_prev) this.setState({ page: this.state.page - 1 }, () => this.refresh()); }} />
        <div style={{ fontSize: 14 }}>第</div>
        <Select
          style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px', marginRight: 8, marginLeft: 8 }}
          variant="outlined"
          value={statePage}
          onChange={e => this.setState({ page: e.target.value }, () => { this.refresh(); })}
        >
          {returnPages().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
        </Select>
        <div style={{ fontSize: 14, marginRight: 8 }}>{`/${pages} 頁，每頁`}</div>
        <Select
          style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px' }}
          variant="outlined"
          value={per_page}
          onChange={e => this.setState({ per_page: e.target.value }, () => { this.search(); })}
        >
          {returnPers().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
        </Select>
        <div style={{ fontSize: 14, marginLeft: 8 }}>{`筆，共${total}筆`}</div>
        <ArrowForwardIos style={{ marginLeft: 5, height: 16, width: 16, color: has_next ? 'black' : 'gray', cursor: has_next ? 'pointer' : 'default' }} onClick={() => { if (has_next) this.setState({ page: this.state.page + 1 }, () => this.refresh()); }} />
        <LastPage style={{ marginRight: 19, height: 24, width: 24, color: canLast ? 'black' : 'gray', cursor: canLast ? 'pointer' : 'default' }} onClick={() => { if (canLast) this.setState({ page: pages }, () => this.refresh()); }} />
        <div style={{ flex: 1 }} />
      </div>
    );
  }

  renderTable=() => {
    const { userListInfo = {} } = this.props;
    const { user_list = [] } = userListInfo;
    const haveData = user_list.length > 0;
    return (
      <TableContainer style={{ marginTop: 18, maxWidth: '98%' }}>
        <Table style={{ backgroundColor: 'white', borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
          {this.renderTableTitle()}
          {haveData && this.renderTableBody()}
        </Table>
      </TableContainer>
    );
  }

  renderMainPage=() => {
    const { deleteUser, userListInfo = {} } = this.props;
    const { currentId, view_checkDelete, currentAct } = this.state;
    const { user_list = [] } = userListInfo;
    const haveData = user_list.length > 0;
    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text='使用者維護管理' />
        {this.toolBar()}
        {this.toolBar2()}
        {this.renderTable()}
        {haveData && this.renderTableBar()}
        {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
        <CheckDelete
          open={view_checkDelete}
          text={`帳號：${currentAct}`}
          onClose={this._close_view_checkDelete}
          search={this.search}
          resKey='DeleteUser'
          onDelete={() => { deleteUser(currentId); }}
        />
      </div>
    );
  }

  render () {
    const { currentId, view_addAndEdit, mode_addAndEdit } = this.state;
    return !view_addAndEdit
      ? this.renderMainPage()
      : <AddAndEdit id={currentId} mode={mode_addAndEdit} _onClose={this._close_view_addAndEdit} />;
  }
}
const mapStateToProps = state => ({
  orgList: state.data.OrgList,
  userListInfo: state.data.UserList,
  ...permission.returnPermission(state),
});
const mapDispatchToProps = dispatch => ({
  getUserList: body => Actions.getUserList(dispatch, body),
  getOrgList: () => Actions.getOrgList(dispatch),
  deleteUser: id => Actions.deleteUser(dispatch, { id }),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
